export interface DemoStep {
  center: [number, number];
  zoom: number;
  pitch: number;
  bearing: number;
  duration: number; // fly animation ms
  dwell: number;    // ms to stay before next step
  highlights: string[];
  narrative: string;
  narrativeDuration: number; // ms — how long narrative stays visible
  alarm?: { driverId: number; code: string };
  toggleTraffic?: boolean; // hide traffic layer → reveal after fly animation
}

// Coordinates from guadalajara.ts intersections
const R1_CENTER: [number, number] = [-3.1720, 40.6352]; // Plaza Mayor
const R2_CENTER: [number, number] = [-3.1751, 40.6331]; // Av. Ejército
const R3_CENTER: [number, number] = [-3.1790, 40.6302]; // Glorieta Boixareu
const R4_CENTER: [number, number] = [-3.1645, 40.6303]; // C/ del Trabajo
export const CITY_CENTER: [number, number] = [-3.1684, 40.6369]; // Guadalajara center

export function buildTrafficStep(
  center: [number, number],
  narrative: string,
): DemoStep {
  return {
    center,
    zoom: 17.5,
    pitch: 40,
    bearing: -15,
    duration: 3000,
    dwell: 18000,
    highlights: ['traffic-buttons'],
    narrative,
    narrativeDuration: 15000,
    toggleTraffic: true,
  };
}

export const DEMO_STEPS: DemoStep[] = [
  {
    // Step 1: Zoom out — overview
    center: CITY_CENTER,
    zoom: 15,
    pitch: 0,
    bearing: 0,
    duration: 2000,
    dwell: 16000,
    highlights: ['header-kpis'],
    narrative: 'Sistema de gestión inteligente ARS_93 — *4 intersecciones* monitorizadas con indicadores de disponibilidad en tiempo real.',
    narrativeDuration: 13000,
  },
  {
    // Step 2: Fly to R1 Plaza Mayor
    center: R1_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: -20,
    duration: 3000,
    dwell: 18000,
    highlights: ['cycle-panel'],
    narrative: 'Panel de ciclo con progreso *por fases* — aparece automáticamente al acercar la cámara a cualquier cruce.',
    narrativeDuration: 15000,
  },
  {
    // Step 3: Fly to R2 Av. Ejército
    center: R2_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: 10,
    duration: 3000,
    dwell: 18000,
    highlights: ['clock-badge'],
    narrative: 'Gestión automática de *planes horarios* — nocturno, base, punta y máxima demanda. Transiciones sin intervención.',
    narrativeDuration: 15000,
  },
  {
    // Step 4: Stay R2 + alarm
    center: R2_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: 10,
    duration: 500,
    dwell: 15000,
    highlights: ['alarm-panel'],
    narrative: 'R2 — !Lámpara fundida! detectada. Clasificación por severidad, registro temporal y notificación al operador.',
    narrativeDuration: 12000,
    alarm: { driverId: 2, code: 'J' },
  },
  {
    // Step 5: Fly to R3 Glorieta
    center: R3_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: -30,
    duration: 3000,
    dwell: 18000,
    highlights: ['cycle-panel'],
    narrative: 'Cada regulador reporta *estado operativo*, plan activo y fase en curso — monitorización continua de grupos semafóricos.',
    narrativeDuration: 15000,
  },
  {
    // Step 6: Fly to R4 C/ Trabajo
    center: R4_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: 15,
    duration: 3000,
    dwell: 16000,
    highlights: ['tts-button'],
    narrative: 'Narración por *voz integrada* — alertas audibles para operadores en sala de control sin mirar la pantalla.',
    narrativeDuration: 13000,
  },
  {
    // Step 7: Zoom out — all 4
    center: CITY_CENTER,
    zoom: 15,
    pitch: 0,
    bearing: 0,
    duration: 3000,
    dwell: 16000,
    highlights: ['overview-bar'],
    narrative: 'Los *reguladores gestionados* muestran fase y estado simultáneamente. Detección inmediata de cualquier anomalía.',
    narrativeDuration: 13000,
  },
  {
    // Step 8: Fly to Av. Ejército panoramic — compare phase offsets
    center: [-3.1744, 40.6318],
    zoom: 16.4,
    pitch: 54.5,
    bearing: 101.2,
    duration: 3000,
    dwell: 16000,
    highlights: ['cabinet-panels'],
    narrative: 'Vista comparativa — los *desfases entre ciclos* se aprecian en los paneles de regulador desplegados simultáneamente.',
    narrativeDuration: 13000,
  },
  {
    // Step 9: Handoff narrative
    center: [-3.1744, 40.6318],
    zoom: 16.4,
    pitch: 54.5,
    bearing: 101.2,
    duration: 500,
    dwell: 12000,
    highlights: [],
    narrative: 'Sistema en *modo supervisión*. Las alarmas se notificarán automáticamente. Explore el mapa libremente.',
    narrativeDuration: 9000,
  },
  {
    // Step 10: Final — fly to opposite panoramic view
    center: [-3.1682, 40.6314],
    zoom: 16.4,
    pitch: 60,
    bearing: -104.9,
    duration: 4000,
    dwell: 5000,
    highlights: ['cabinet-panels'],
    narrative: '',
    narrativeDuration: 0,
  },
];
